export enum ECallProvider {
  LiveKit,
  Trtc,
}

export enum ERole {
  Guest = 0,
  Host = 1,
}

export enum EMainNodeType {
  Clear,
  Uncertain,
  Forgetful,
  Confused,
  Disconnected,
}

export enum ESubNodeType {
  Detection,
  Prevention,
  Treatment,
  Care,
}
